import React, { Fragment } from "react";
import Exp from "./Exp";

function Experience(props) {
    return (
        <Fragment>
            <div id="experience">
                <Exp />
            </div>
        </Fragment>
    )
}
export default Experience;
